// @flow

import { combineReducers } from 'redux';
import {
  GET_OPENING_HOURS,
  GET_OPENING_HOURS_SUCCESS,
  GET_OPENING_HOURS_FAILED,
} from './constants';
import type { OpeningHours } from '../../types';

const initialState: OpeningHours = {
  open: false,
  open_from: '',
  open_till: '',
  currentTime: '',
};

export type OpeningHoursState = typeof initialState;

type StartFetchOpeningHours = {
  type: typeof GET_OPENING_HOURS,
};

type ReceivedOpeningHours = {
  type: typeof GET_OPENING_HOURS_SUCCESS,
  payload: OpeningHours,
};

type FailedOpeningHours = {
  type: typeof GET_OPENING_HOURS_FAILED,
  payload: any,
};

const openingHours = (
  state: OpeningHoursState = initialState,
  action: ReceivedOpeningHours,
): OpeningHoursState => {
  switch (action.type) {
    case GET_OPENING_HOURS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const isFetching = (
  state: boolean = false,
  action: StartFetchOpeningHours | ReceivedOpeningHours | FailedOpeningHours,
) => {
  switch (action.type) {
    case GET_OPENING_HOURS:
      return true;
    case GET_OPENING_HOURS_SUCCESS:
    case GET_OPENING_HOURS_FAILED:
      return false;
    default:
      return state;
  }
};

const isFetched = (
  state: boolean = false,
  action: StartFetchOpeningHours | ReceivedOpeningHours | FailedOpeningHours,
) => {
  switch (action.type) {
    case GET_OPENING_HOURS:
    case GET_OPENING_HOURS_FAILED:
      return false;
    case GET_OPENING_HOURS_SUCCESS:
      return true;
    default:
      return state;
  }
};

export type State = {
  isFetching: boolean,
  isFetched: boolean,
  openingHours: OpeningHoursState,
};

export default combineReducers<Object, Object>({
  isFetching,
  isFetched,
  openingHours,
});
